// extracted by mini-css-extract-plugin
export default {"stageColor":"note-change-data-template_stageColor__KWhn1"};